import { StylesConfig } from 'react-select';

const statusColors: Record<number, string> = {
  11: '#00A3FF', // Enviado
  13: '#45B26B', // En almacén
  14: '#F04438', // Devuelto
  15: '#F04438', // Agotado
};

export const statusSelectStyles: StylesConfig<any, true> = {
  clearIndicator: (provided) => ({
    ...provided,
    padding: '2px',
    fontSize: '12px',
    svg: {
      height: '12px',
      width: '12px',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#181c32',
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#7E8199',
  }),
  control: (styles, { isDisabled }) => ({
    ...styles,
    width: '135px',
    border: '1px solid #e4e6ef',
    marginTop: '5px',
    borderRadius: '6px',
    boxShadow: 'none',
    backgroundColor: isDisabled ? '#EFF2F5' : 'white',
  }),
  valueContainer: (provided) => ({
    ...provided,
    maxHeight: '30px',
    overflowY: 'auto',
    paddingBottom: 0,
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const baseColor = statusColors[data.value] || '#EFF2F5';
    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
        ? baseColor
        : isFocused
        ? `${baseColor}33`
        : undefined,
      color: isDisabled ? '#ccc' : isSelected ? '#ffffff' : '#181C32',
      cursor: isDisabled ? 'not-allowed' : 'default',
      fontWeight: isSelected ? 600 : 400,
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled
          ? isSelected
            ? baseColor
            : `${baseColor}55`
          : undefined,
      },
    };
  },
  multiValue: (styles, { data }) => {
    const baseColor = statusColors[data.value] || '#EFF2F5';
    return {
      ...styles,
      backgroundColor: `${baseColor}33`,
      borderRadius: '4px',
    };
  },
  multiValueLabel: (styles) => ({
    ...styles,
    color: '#181C32',
    fontWeight: 500,
  }),
  multiValueRemove: (styles, { data }) => {
    const baseColor = statusColors[data.value] || '#E4E6EF';
    return {
      ...styles,
      color: '#7E8299',
      ':hover': {
        backgroundColor: baseColor,
        color: '#000',
      },
    };
  },
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

export const statusSelectModalStyles: StylesConfig<any> = {
  control: (styles) => ({
    ...styles,
    width: '100%',
    maxWidth: '100%',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

export const selectStylesMov: StylesConfig<any, true> = {
  clearIndicator: (provided) => ({
    ...provided,
    padding: '2px',
    fontSize: '12px',
    svg: {
      height: '12px',
      width: '12px',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#181c32',
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#7E8199',
  }),
  control: (styles, { isDisabled }) => ({
    ...styles,
    width: '100%',
    border: '1px solid #e4e6ef',
    marginTop: '5px',
    borderRadius: '6px',
    boxShadow: 'none',
    backgroundColor: isDisabled ? '#EFF2F5' : 'white',
  }),
  valueContainer: (provided) => ({
    ...provided,
    maxHeight: '30px',
    overflowY: 'auto',
    paddingBottom: 0,
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const baseColor = statusColors[data.value] || '#EFF2F5';
    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
        ? baseColor
        : isFocused
        ? `${baseColor}33`
        : undefined,
      color: isDisabled ? '#ccc' : isSelected ? '#ffffff' : '#181C32',
      cursor: isDisabled ? 'not-allowed' : 'default',
      fontWeight: isSelected ? 600 : 400,
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled
          ? isSelected
            ? baseColor
            : `${baseColor}55`
          : undefined,
      },
    };
  },
  multiValue: (styles, { data }) => {
    const baseColor = statusColors[data.value] || '#EFF2F5';
    return {
      ...styles,
      backgroundColor: `${baseColor}33`,
      borderRadius: '4px',
    };
  },
  multiValueLabel: (styles) => ({
    ...styles,
    color: '#181C32',
    fontWeight: 500,
  }),
  multiValueRemove: (styles, { data }) => {
    const baseColor = statusColors[data.value] || '#E4E6EF';
    return {
      ...styles,
      color: '#7E8299',
      ':hover': {
        backgroundColor: baseColor,
        color: '#000',
      },
    };
  },
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};
